import React from "react";
import { TrendingDown, UserX, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { DATA_CARDS } from "@/data/content";

const ICON_MAP = { TrendingDown, UserX, ShieldCheck };

export const DataSection = () => {
  return (
    <section id="market" data-testid="market-section" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            overline="Why it matters"
            title="Late payments are not a small problem."
            subtitle="Across service businesses, freelancers, and B2B vendors, delayed payments create cash-flow pressure and unnecessary stress."
            center
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {DATA_CARDS.map((d, i) => {
            const Icon = ICON_MAP[d.icon];
            return (
              <Reveal key={d.title} delay={i * 0.08}>
                <div
                  data-testid={`data-card-${i}`}
                  className="h-full bg-white rounded-3xl border border-slate-100 soft-shadow p-8"
                >
                  <div className="h-12 w-12 rounded-2xl bg-[#eef4fb] flex items-center justify-center mb-6">
                    <Icon className="h-6 w-6 text-[#2563eb]" />
                  </div>
                  <h3 className="font-display text-xl font-bold text-[#091630] mb-3">{d.title}</h3>
                  <p className="text-[15px] text-slate-500 leading-relaxed">{d.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 text-center">
            <p className="text-sm text-slate-400">
              Sources: PYMNTS Intelligence, freelancer payment surveys, B2B late-payment reports.
            </p>
            <p className="text-xs text-slate-300 mt-2 max-w-xl mx-auto">
              Statistics vary by market and industry. Workpay solves the workflow problem behind the numbers.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default DataSection;
